var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuestionSolid = function SvgQuestionSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.75c3.855 0 7 3.145 7 7 0 3.883-3.145 7-7 7-3.883 0-7-3.117-7-7 0-3.855 3.117-7 7-7Zm0 10.938a.881.881 0 0 0 .875-.876.881.881 0 0 0-.875-.874c-.52 0-.875.382-.875.874 0 .493.383.876.875.876Zm1.887-3.883c.601-.356.957-.985.957-1.64 0-1.067-.848-1.915-1.969-1.915H11.48c-1.039 0-1.886.848-1.886 1.914 0 .356.3.656.656.656.355 0 .656-.3.656-.656a.59.59 0 0 1 .602-.601h1.394c.329 0 .63.273.63.601 0 .219-.11.41-.302.52l-1.558.93a.674.674 0 0 0-.328.573v.438c0 .355.3.656.656.656.355 0 .656-.3.656-.656v-.055l1.23-.765Z"
  })));
};

export default SvgQuestionSolid;